
import React from 'react'

const SaveIcon = ({width, height, opacity}) => {
    return (
        <svg
            width={width} 
            height={height} 
            viewBox="0 0 14 14" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M13.6044 2.70451L12.1692 0.789744C11.7981 0.295077 11.2079 0 10.5897 0H1.97436C0.885231 0 0 0.885231 0 1.97436V12.0256C0 13.1148 0.885231 14 1.97436 14H12.0256C13.1148 14 14 13.1148 14 12.0256V3.88913C14 3.46482 13.86 3.0441 13.6044 2.70451ZM4.66667 1.07692H9.33333V3.41026C9.33333 3.50933 9.25292 3.58974 9.15385 3.58974H4.84615C4.74708 3.58974 4.66667 3.50933 4.66667 3.41026V1.07692ZM3.23077 12.9231V8.4359C3.23077 7.94123 3.63354 7.53846 4.12821 7.53846H9.87179C10.3665 7.53846 10.7692 7.94123 10.7692 8.4359V12.9231H3.23077ZM12.9231 12.0256C12.9231 12.5203 12.5203 12.9231 12.0256 12.9231H11.8462V8.4359C11.8462 7.34677 10.9609 6.46154 9.87179 6.46154H4.12821C3.03908 6.46154 2.15385 7.34677 2.15385 8.4359V12.9231H1.97436C1.47969 12.9231 1.07692 12.5203 1.07692 12.0256V1.97436C1.07692 1.47969 1.47969 1.07692 1.97436 1.07692H3.58974V3.41026C3.58974 4.10308 4.15333 4.66667 4.84615 4.66667H9.15385C9.84667 4.66667 10.4103 4.10308 10.4103 3.41026V1.07692H10.5897C10.8712 1.07692 11.1397 1.21118 11.3077 1.4359L12.7436 3.35067C12.8592 3.50503 12.9231 3.696 12.9231 3.88913V12.0256Z" 
                fill="currentColor"
            />
        </svg>
    )
}

export default SaveIcon

SaveIcon.defaultProps = {
    width: '14',
    height: '14',
}